/** Venuefy brand mark — SVG recreation of the official logo (V + waveform).
 *  Theme-able: purple/navy on the marketing site, wedding-motif colors inside
 *  event sites (per brand guidance: color follows the event's theme).
 */
export default function VenuefyMark({ size = 36, left = "#171a3a", right = "#7c3aed", bars = "#7c3aed", className = "" }) {
  return (
    <svg width={size} height={size * 0.8} viewBox="0 0 100 80" fill="none" className={className} aria-label="Venuefy" role="img">
      {/* left stroke of the V */}
      <polygon points="4,10 23,10 57,76 38,76" fill={left} />
      {/* right stroke of the V */}
      <polygon points="77,10 96,10 62,76 43,76" fill={right} />
      {/* waveform */}
      <rect x="30" y="22" width="5.5" height="14" rx="2.75" fill={bars} />
      <rect x="39" y="10" width="5.5" height="30" rx="2.75" fill={bars} />
      <rect x="48" y="17" width="5.5" height="21" rx="2.75" fill={bars} />
      <rect x="57" y="25" width="5.5" height="11" rx="2.75" fill={bars} />
      <rect x="66" y="29" width="5.5" height="7" rx="2.75" fill={bars} />
    </svg>
  );
}
